/**
 * Best-effort JSON pretty-printer used by the Transactions and Webhooks
 * payload viewers. If the input isn't valid JSON, returns it verbatim so the
 * viewer can still show whatever was captured.
 */
export function tryPrettyJson(raw: string): string {
  try {
    const parsed = JSON.parse(raw);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return raw;
  }
}

/** Render a byte-count as `123 B` / `4.2 KB` / `1.3 MB` for inline labels. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(1)} MB`;
}
